import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ComponentView } from 'src/modules/app-template/models/component-view.model';
import { RestEndpoint } from 'src/modules/sm-base/models/rest-endpoint.model';
import { Arrays } from 'src/modules/utils/shared/arrays';
import { EnaioDocumentsModule } from '../../enaio-documents.module';
import { EnaioDocumentFrontendResult } from '../../netgen/EnaioDocumentFrontendResult';

@Component({
    selector: 'app-enaio-documents-main',
    templateUrl: './enaio-documents-main.component.html',
    styleUrls: [],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EnaioDocumentsMainComponent extends ComponentView {

    definitions: EnaioDocumentFrontendResult[] = [];

    async initParams(): Promise<boolean> {
        this.app.updateNavigation("Dokumente", [EnaioDocumentsModule.mainBreadcrumb, { label: "Dokumente", url: "/enaio-documents/home" }]);
        const definitions = await RestEndpoint.main().query({ includeResultCounts: false }).run("api/doc/def").list(EnaioDocumentFrontendResult);
        const documentTypeSelectionGroup = definitions[0]?.documentTypeSelectionGroup;
        if (definitions.length > 0 && definitions.find(def => !def.anonymousOnly) == null) {
            await this.app.navigateTo(["/enaio-documents", "as", definitions[0].defId]);
        }
        else if (definitions.length == 1) {
            await this.app.navigateTo(["/enaio-documents", "definition", definitions[0].defId]);
        }
        else if (documentTypeSelectionGroup != null && documentTypeSelectionGroup != "" &&
            definitions.every(def => def.documentTypeSelectionGroup == documentTypeSelectionGroup)) {
            await this.app.navigateTo(["/enaio-documents", "definition", definitions[0].defId], true);
        }
        else {
            this.definitions = Arrays.sortBy(await RestEndpoint.main().query({ includeResultCounts: true }).run("api/doc/def").list(EnaioDocumentFrontendResult), def => def.name);
        }
        return true;
    }

    async click(def): Promise<void> {
        await this.app.navigateTo(["/enaio-documents", "definition", def.defId]);
    }

}
